import { CardContent, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialButton from "../../../components/MaterialButton"
import { Add, FileUpload, FilterAlt } from "@mui/icons-material"
import Table from "../../../components/Table"
import { useEffect, useState } from "react"
import { deleteData, fetchData, postData } from "../../../services"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import UploadFile from "../../Utils/UploadFile"
import { useSnackbar } from "../../../context/popup"
import { setCircleLoading } from "../../../components/Loading";
import InsurerDiscountFilterDialog from './components/InsurerDiscountFilterDialog.js';

const InsurerDiscountList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentPage = useSelector((state) => state?.insurerDiscountStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.insurerDiscountStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.insurerDiscountStore?.totalPages);
    const [search, setSearch] = useState("");
    const [isRefresh, setIsRefresh] = useState(false);
    const [insurerDiscountData, setInsurerDiscountData] = useState([]);
    const { showSnackbar } = useSnackbar();

        //dialogstate
    const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
    const [fileUploading, setFileUploading] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [clearFileOnSuccess, setClearFileOnSuccess] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        gInsurerId: "",
        gDiscountId: ""
    });

    useEffect(() => {
        fetchDiscountList();
    },[isRefresh, currentPage, rowsPerPage,search])

    const handleSearch = (value) => {
        setSearch(value);
    };

    //List API
    const fetchDiscountList = async () => {
        setCircleLoading(true);
        try {
        let url = `/reference/insurer/discount?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`;
                                    
        //for active and inactive status
        if(filterData.isActive !== "") {
            url += `&isActive=${filterData.isActive}`;
        }
        if(filterData.gInsurerId !== "") {
            url += `&gInsurerId=${filterData.gInsurerId}`;
        }
        if(filterData.gDiscountId !== "") {
            url += `&gDiscountId=${filterData.gDiscountId}`;
        }    
    
        const response = await fetchData(url);
        if(response?.success){
            setInsurerDiscountData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));     
        }
        else{
            //throw error
        }
        } catch (error) {
            console.error('Error Fetching Discounts:', error);
            showSnackbar(error?.response?.data?.message || 'Error Fetching Discounts:',"error");
        }
        finally{
            setCircleLoading(false);
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        setCircleLoading(true);
        try {
            const response = await deleteData(`/reference/insurer/discount-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message,"success");
            }
            else{
                showSnackbar(response?.message,"error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
        }
        finally{
            setCircleLoading(false);
        }
    };

    //table mapping
    const insurerDiscountTable = {
        columns: [
            {
            key: "sno",
            label: "S.No.",
            renderCell: (row) => row.sno,
            },
            {
            key: "code",
            label: "Coverage Code",
            renderCell: (row) => row.code,
            },
            {
            key: "name",
            label: "Coverage Name",
            renderCell: (row) => row.name,
            },
            {
            key: "gInsurerName",
            label: "Insurer Name",
            renderCell: (row) => row.gInsurerName,
            },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            },
        ],
        rows: insurerDiscountData?.map((item, index) => ({
            id: item?.id,
            sno: index + 1,
            code: item?.code || "",
            name: item?.name || "",
            gInsurerName: item?.gInsurerName || "",
            isActive: item?.isActive,
        })),
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/insurer-master/insurer-discount/discount-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/insurer-master/insurer-discount/discount-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleAddNewDiscount = () => {
        navigate(`/insurer-master/insurer-discount/discount-details`)
    };

    //bulk file upload api function
    const handleFileUploadSuccess = async (file) => {
        setFileUploading(true)
        setUploadSuccess(false)

        try {
            const formData = new FormData()

            formData.append('file', file)

            const result = await postData(`/reference/motor/insurer/bulkUpload/insurer-discount`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });        

            if (result?.success) {
                setUploadSuccess(true)
                showSnackbar(result?.message,"success");
                setOpenUploadFileDialog(false);
                setClearFileOnSuccess(true);
                fetchDiscountList(); 
            }
            else {
                setUploadSuccess(false);
                showSnackbar('Faiiled to upload file', "error")
            }

        } catch (error) {
                const errorMessage = error?.response?.data?.message;                
                console.error('Upload error:', error || errorMessage)
                showSnackbar(errorMessage, "error")
        } 
        finally {
                setFileUploading(false)
        }
    };

  return (
    <DashboardLayout>
        <CardHeader title={(
            <Stack
                direction={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Insurer Discount List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of Insurer based Discounts.
                    </MaterialTypography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FilterAlt/>}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    >
                    Filter
                    </MaterialButton>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FileUpload/>}
                     onClick={() => setOpenUploadFileDialog(true)}
                    >
                        Bulk Upload
                    </MaterialButton>
                    <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<Add />}
                        onClick={() => handleAddNewDiscount()}
                    >
                        Discount
                    </MaterialButton>
                </Stack>
            </Stack>
        )} 
        />
        <CardContent>
            <Table
            columns={insurerDiscountTable?.columns}
            data={insurerDiscountTable?.rows}
            actions={actions}
            pagination={{
                totalPages,
                currentPage,
                onPageChange: (page) => handlePaginationChange(page),
                rowsPerPage,
                onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                rowsPerPageOptions: [5, 10, 15, 20],
            }}
            getRowKey={(row) => row.id}
            className="custom-table"
            noDataLabel="No Insurer Discounts found"
            handleSearch={handleSearch}
            />
        </CardContent>

        <UploadFile
        open={openUploadFileDialog}
        setOpen={setOpenUploadFileDialog}
        onUploadSuccess={handleFileUploadSuccess}
        fileTypes={['csv', 'xlsx']}
        fileUploading={fileUploading}
        uploadSuccess={uploadSuccess}
        setUploadSuccess={setUploadSuccess}
        setFileUploading={setFileUploading}
        clearFileOnSuccess={clearFileOnSuccess}
        />
        <InsurerDiscountFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchDiscountList();  // call API after filter applied
        }}
        />
    </DashboardLayout>
  )
}

export default InsurerDiscountList